import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isValid$, NgDialogModule } from '@principle-theorem/ng-shared';
import { IPracticeUserRestriction } from '@principle-theorem/principle-core/interfaces';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserRestrictionIpOverrideFormGroup } from '../user-restriction-ip-override-form';
import { UserRestrictionScheduleFormGroup } from '../user-restriction-schedule-form';
import { UserRestrictionFormComponent } from '../user-restriction-form/user-restriction-form.component';

export interface IEditUserRestrictionRequest {
  restriction: IPracticeUserRestriction;
}

@Component({
  selector: 'pr-edit-user-restriction-dialog',
  templateUrl: './edit-user-restriction-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgDialogModule, UserRestrictionFormComponent],
})
export class EditUserRestrictionDialogComponent {
  private _dialogRef =
    inject<
      MatDialogRef<EditUserRestrictionDialogComponent, IPracticeUserRestriction>
    >(MatDialogRef);
  readonly data = inject<IEditUserRestrictionRequest>(MAT_DIALOG_DATA);
  readonly scheduleGroup = new UserRestrictionScheduleFormGroup();
  readonly ipOverrideGroup = new UserRestrictionIpOverrideFormGroup();
  readonly saveDisabled$: Observable<boolean>;

  constructor() {
    const { schedule, ipWhitelist } = this.data.restriction;

    if (schedule?.length) {
      this.scheduleGroup.setSchedule(schedule);
    } else {
      this.scheduleGroup.resetToDefault();
    }

    this.ipOverrideGroup.setIpWhitelist(ipWhitelist);

    this.saveDisabled$ = isValid$(this.scheduleGroup).pipe(
      map((scheduleValid) => !scheduleValid)
    );
  }

  save(): void {
    const ipWhitelist = this.ipOverrideGroup.getIpWhitelist();
    this._dialogRef.close({
      user: this.data.restriction.user,
      schedule: this.scheduleGroup.getSchedule(),
      ipWhitelist,
    });
  }
}
